<template>
  <div>
    <el-dialog :visible.sync="dialogVisible1" :append-to-body="true" width="30%" :show-close=false z-index="99999" :close-on-click-modal="false" :close-on-press-escape="false">
      <div slot="title" class="dialog-title">
        <div class="head">
          <div class="headname">
            我的订单
          </div>
        </div>
        <div @click="onCLose">
          <img src="../../../../public/images/close.svg" alt="">
        </div>
      </div>
      <div class="ordercentent" v-if="orderlist.length">
        <el-table
          v-loading="loading"
          :data="formattedActualPrice"
          style="width: 100%"
          height="480"
          :header-cell-style="{ background: '#F7F9FF', color: '#323233' }"
          :cell-style="{ padding: '12px 0' }">
          <el-table-column prop="orderId" label="订单编号" min-width="180">
            <template slot-scope="scope">
              <span class="order-id">{{ scope.row.orderId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="商品名称" min-width="180">
            <template slot-scope="scope">
              <span class="product-name">{{ scope.row.productName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="duration" label="会员时长" min-width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.duration }}天</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualPrice" label="支付金额" min-width="120">
            <template slot-scope="scope">
              <span class="price">¥{{ scope.row.actualPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="paidAt" label="支付时间" min-width="180" :formatter="(row) => formatDate(row.paidAt)">
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="total"
            layout="prev, pager, next"
            background>
          </el-pagination>
        </div>
      </div>
      <div class="ordercentent" v-else>
        <div class="noorder">
          <div class="noorder-img">
            <img src="../../../../public/images/noorder.png" alt="">
          </div>
          <div class="orderlog">
            暂无订单记录
          </div>
          <div class="btn">
            <el-button type="primary" @click="handleMemberPurchase">会员开通</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderPageList } from '@/api/chat';
export default {
  name: 'Order',
  mounted() {
    if (!this.isLogin) return;
    this.orderLi();
  },
  data() {
    return {
      orderlist: [],
      orderId: '',
      status: 0,
      loading: false,
      currentPage: 1,
      pageSize: 8,
      total: 0
    };
  },
  props: ['dialogVisible1', 'isLogin'],
  methods: {
    onCLose() {
      this.$emit('cloeseDialogorder');
    },
    handleMemberPurchase() {
      this.$emit('cloeseDialogorder');
      this.$emit('openMemberPurchase');
    },
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000); // 转换为毫秒
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
    },

    orderLi() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize
      };
      orderPageList(params).then(res => {
        if (res.code === 200) {
          this.orderlist = res.data.list;
          this.total = res.data.total || 100;
        } else {
          this.$message.error(res.message || '获取订单列表失败');
        }
      }).catch(err => {
        this.$message.error('获取订单列表失败');
        console.error('获取订单列表失败:', err);
      }).finally(() => {
        this.loading = false;
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.orderLi();
    }
  },
  watch: {
    dialogVisible1(newVal) {
      if (newVal) {
        this.orderLi();
      } else {
        // 清除数据
        this.orderlist = [];
        this.currentPage = 1;
        this.total = 0;
      }
    }
  },
  computed: {
    formattedActualPrice() {
      return this.orderlist.map(order => ({
        ...order,
        actualPrice: order.actualPrice / 100
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-title {
  display: flex;
  justify-content: space-between;
}

.head {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 8px;
  height: 23px;
}

.headname {
  color: #0F0F10;
  font-family: "PingFang SC";
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 100% */
}

.ordercentent {
  margin-top: 20px;
  width: 100%;
  height: calc(100% - 60px);
  position: relative;
  padding: 0 20px;
}

.noorder {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 279px;
  height: 292px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .noorder-img {
    position: relative;
  }
}

.orderlog {
  width: 84px;
  height: 14px;
  margin-bottom: 25px;
}

.ordertop {
  width: 1180px;
  height: 60px;
  flex-shrink: 0;
  background-color: #F7F9FF;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.btn {
  width: 160px;
  height: 46px;
}

::v-deep .el-dialog {
  border-radius: 10px !important;
  width: 1240px !important;
  height: 680px !important;
  flex-shrink: 0;
  position: relative;
}

::v-deep .el-dialog__body {
  padding: 0 20px;
  height: calc(100% - 60px);
}

::v-deep .el-table {
  margin: 0;
}

::v-deep .el-table th>.cell {
  height: 60px;
  line-height: 60px;
  background: #F7F9FF;
  color: #323233;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  text-align: center;
}

::v-deep .el-table .cell {
  text-align: center;
}

::v-deep .el-table th.is-leaf {
  border-width: 0px;
}

::v-deep .el-button--primary {
  width: 160px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(153deg, #3774F3 -24.36%, #1A87F4 106.05%);
}

.pagination-container {
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
}

.order-id {
  color: #3774F3;
  cursor: pointer;
}

.product-name {
  font-weight: 500;
}

.price {
  color: #FF4D4F;
  font-weight: 500;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #3774F3;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #3774F3;
}

// 添加关闭按钮的鼠标指针样式
.dialog-title > div:last-child {
  cursor: pointer;
}
</style>
